import React from "react";

import SkeletonBlock from "./SkeletonBlock";

/**
 * Renders one or more text-line skeletons.
 *
 * @param {number}   lines   — Number of text lines (default: 1)
 * @param {string[]} widths  — Per-line width overrides (default: randomised)
 * @param {string}   gap     — Gap between lines (default: 'var(--skeleton-gap-sm)')
 * @param {string}   size    — 'sm' | 'md' | 'lg' (maps to text height tokens)
 * @param {string}   className — extra classNames for the container
 */
const DEFAULT_WIDTHS = ["100%", "85%", "70%", "90%", "60%"];

const SIZE_MAP = {
  sm: "var(--skeleton-text-height-sm)",
  md: "var(--skeleton-text-height)",
  lg: "var(--skeleton-text-height-lg)",
};

const SkeletonText = ({
  lines = 1,
  widths,
  gap = "var(--skeleton-gap-sm)",
  size = "md",
  className,
}) => {
  const height = SIZE_MAP[size] || SIZE_MAP.md;

  return (
    <div
      className={className}
      style={{ display: "flex", flexDirection: "column", gap }}
    >
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock
          key={i}
          width={widths?.[i] ?? DEFAULT_WIDTHS[i % DEFAULT_WIDTHS.length]}
          height={height}
          radius="sm"
        />
      ))}
    </div>
  );
};

export default SkeletonText;
